import { useCallback } from 'react';
import { useVersionedCache } from './useVersionedCache';
import { cmsApi, EbookDto } from '../services/cmsApi';

/** Danh sách ebook (đang bật) — cache version-gate + 24h. */
export function useEbooks() {
  const fetcher = useCallback(() => cmsApi.getEbooks(), []);
  return useVersionedCache<EbookDto[]>('tuki_ebook_cache', fetcher);
}
